<template>
  <div class="tab-pane-body sku-tab-body">
    <div class="sku-form-page">
      <section class="sku-detail sku-detail-demo" v-if="pa.activeSku">
        <div class="sku-toolbar">
          <div>
            <h3 class="sku-detail-title">
              {{ pa.activeSku.skuName ? ('规格信息 - ' + pa.activeSku.skuName) : '规格信息' }}
            </h3>
            <div class="sku-meta">
              SKU编码：{{ pa.activeSku.skuCode || '待生成' }}
              　状态：{{ pa.normalizeStatus(pa.activeSku.status) }}
              <template v-if="pa.form.spuCode">　所属SPU：{{ pa.form.spuCode }}</template>
            </div>
          </div>
        </div>

        <!-- SKU 直建：不用内层 Tabs，避免 inactive 面板导致无法输入 -->
        <div v-if="pa.formMode === 'sku'" class="sku-inner-flat">
          <product-sku-spec-sections />
          <div class="section sku-direct-price-block">
            <div class="section-head">
              <div class="section-title">价格体系 <small>规格维度独立维护；保存 SKU 后可绑定仓库指导价</small></div>
            </div>
          </div>
          <guide-price-editor
            :sku-id="pa.activeSku && pa.activeSku.id"
            :readonly="pa.formReadonly"
            :sale-rate="pa.salePriceRate(pa.activeSku)"
            :sale-unit-name="pa.salePriceUnitName(pa.activeSku)"
            :case-rate="pa.activeSku && pa.activeSku.caseRate != null ? pa.activeSku.caseRate : 1"
            :base-unit-name="pa.activeSku && (pa.activeSku.configBaseUnit || pa.activeSku.baseUnitName || pa.form.baseUnit)" />
        </div>

        <a-tabs v-else v-model="pa.skuInnerTab" class="sku-inner-tabs" :animated="false" :destroyInactiveTabPane="true">
          <a-tab-pane key="spec" tab="规格信息">
            <product-sku-spec-sections />
          </a-tab-pane>
          <a-tab-pane key="price" tab="价格体系">
            <guide-price-editor
              :sku-id="pa.activeSku && pa.activeSku.id"
              :readonly="pa.formReadonly"
              :sale-rate="pa.salePriceRate(pa.activeSku)"
              :sale-unit-name="pa.salePriceUnitName(pa.activeSku)"
              :case-rate="pa.activeSku && pa.activeSku.caseRate != null ? pa.activeSku.caseRate : 1"
              :base-unit-name="pa.activeSku && (pa.activeSku.configBaseUnit || pa.activeSku.baseUnitName || pa.form.baseUnit)" />
          </a-tab-pane>
        </a-tabs>
      </section>
    </div>
  </div>
</template>

<script>
import GuidePriceEditor from './GuidePriceEditor.vue'
import ProductSkuSpecSections from './ProductSkuSpecSections.vue'

export default {
  name: 'ProductSkuEditPanel',
  components: { GuidePriceEditor, ProductSkuSpecSections },
  inject: {
    pa: { from: 'productArchiveVm', default: null }
  }
}
</script>
